import { render, staticRenderFns } from "./AtomLegalLinks.vue?vue&type=template&id=a4d38ea4&"
import script from "./AtomLegalLinks.vue?vue&type=script&lang=js&"
export * from "./AtomLegalLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomLegalLinks.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fcommon%2FAtomLegalLinks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports